import React, { Component } from "react";
// import LinkageImg from "Assets/images/linkage.svg";
import "./index.less";
// const IconSize = 14;
import { langCheck } from "Pub/js/utils";
import platform from "Pub/js/platform";
const { NCPopover } = platform.base;

export default class LinkageIcons extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { linkIcons } = this.props;
        // const sizeStyle = {
        //     width: IconSize,
        //     height: IconSize
        // }
        const activeLinkData = linkIcons.find(item => item.type === 'to');
        if (!activeLinkData) { return null; }
        const linkContent = <div>
            <span>{langCheck('0000PUB-000633')}:</span>
            {
                activeLinkData.linkConfig.map(item =>
                    <p className="link-item" key={item.key}>{item.value}</p>,
                )
            }
        </div>;
        return <NCPopover
            placement="right"
            content={linkContent}
            trigger="hover"
            className="link-popover"
        >
            <i className="iconfont icon-shuoming1 icon-link-help"></i>
        </NCPopover>;
        // <div className="linkage-icons">
        //     {
        //         linkIcons.map(item => <div className="link-icon-container" style={ sizeStyle }>
        //             <img className="link-icon" style={{ filter: `drop-shadow(${item.color || '#E51373'} ${IconSize}px ${IconSize}px)` }} src={LinkageImg}></img>
        //         </div>)
        //     }
        // </div>
    }
}